module.exports = __webpack_public_path__ + "img/olympics.56ad6c07.svg";